import React, {useState, useEffect, forwardRef, useImperativeHandle} from 'react';
import {useDispatch} from 'react-redux';
import { useTranslation } from 'react-i18next';
import BoardService from '../../../services/board.service';
import TextField from '../../../../styled-base/input/text';
import CloseIcon from '@material-ui/icons/Close';
import SvgIcon from '@material-ui/core/SvgIcon';
import {searchMatchedTextValue} from '../../../../utils/common';
import {updateColumnAutomationData} from '../../../actions/column.actions';
import {constructUserAutomationData} from '../../../utils/board';

const UserAutomation = forwardRef(({columnId, data, onClose}: any, ref: any) => {
    const { t } = useTranslation();
    const boardService = new BoardService();
    const initialData: any = data || {};
    const dispatch = useDispatch();
    const [automationData, setAutomationData] = useState<any>(initialData);
    const [wsLists, setWsLists] = useState<any>([]);
    const [searchList, setSearchList] = useState<any>([]);
    const [text, setText] = useState<string>('');

    useEffect(() => {
        boardService.getBoardWsLists({allTags: "true" })
            .then(response => {
                const {wsList} = response.data;
                setWsLists(wsList || []);
            });
    }, []);

    useImperativeHandle(ref, () => ({
        onReset() {
            setAutomationData(initialData);
        },
        async onDone() {
            showLoaderWidget(document.getElementById('content'));
            let params: any = {
                columnId,
                leave_user: automationData.leave_user ? 1 : 0,
                set_user_availability: automationData.set_user_availability ? 1 : 0,
                ws_ids: automationData.ws_ids.map((ws: any) => ws.id)
            };
            console.log('params', params);
            const response = await boardService.saveColAutomationPeopleData(params);
            const responseData = response.data.response.data;
            let data: any = constructUserAutomationData(responseData);
            dispatch(updateColumnAutomationData(columnId, responseData.isAutomated, data));
            removeLoader();
            onClose();
        }
    }));

    const toggleBox = (e: any) => {
        const checked = e.target.checked;
        const name = e.target.name;
        setAutomationData({...automationData, [name]: (checked ? 1: 0)})
    }

    const searchText = (e: any) => {
        let value = e.target.value.trim();
        setText(value);
        let cloneList = [];
        if (value.length > 0) {
            value = value.toLowerCase();
            cloneList = wsLists.filter((item: any) => {
                if (value) {
                    const itemName = item.name.toLowerCase();
                    return searchMatchedTextValue(itemName, value);
                }
                return true;
            });
        }
        setSearchList(cloneList);
    }

    const onRemmove = (ws: any) => {
        setAutomationData({
            ...automationData, 
            ws_ids: automationData.ws_ids.filter((w: any) => w.id != ws.id)
        })
    }

    const onSelectOption = (e: any, list: any) => {
        console.log('select', list);
        setSearchList([]);
        setText('');
        let ws_ids = automationData.ws_ids;
        const findWs = ws_ids.find((ws: any) => ws.id == list.id);
        if (!findWs) {
            ws_ids.unshift({id: list.id, name: list.name});
        }
        setAutomationData({
            ...automationData, 
            ws_ids    
        })
    }

    return (
        <div className='board-column-automation'>
            <div className='flex-row'>
                <div className='automation-head'>
                    {t('Link column to an existing workstream')}
                </div>
            </div>
            <div className='flex-row'>
                <div className='flex-column width100'>
                    <div className='flex-column' style={{position: 'relative'}}>
                        <TextField 
                            inputProps = {{
                                id: 'auto-searchws',
                                name: 'auto_searchws',
                                value: text,
                                placeholder: t('Search for a workstream to link to'),
                                style: {
                                    width: '60%'
                                }
                            }}
                            onChangeText= {searchText}
                        />
                        { searchList.length ? (
                            <div style={{width: '60%'}}>
                                <div 
                                    className='listbox-options-wrapper listbox-options-ws-wrapper'>    
                                    {
                                        searchList.map((list: any, index: any) => (
                                            <div key={`list_${index}`} 
                                                className='listbox-option truncateText'
                                                onClick={(e) => onSelectOption(e, list)}
                                                >
                                                {list.name}
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ) : ''}
                    </div>
                </div>
            </div>
            {
                automationData.ws_ids.length ? ( 
                    <div className='flex-ws-wrapper'>
                    { 
                        automationData.ws_ids.map((ws: any) => (
                            <div key={`ws_${ws.id}`} className='flex-row flex-ws-row'>
                                <div className='ws-name'>{ws.name}</div>
                                <div className='ws-close'>
                                <SvgIcon
                                    htmlColor="grey"
                                    onClick={() => onRemmove(ws)}
                                    style={{fontSize: '15px', cursor: 'pointer'}}
                                >
                                    <CloseIcon />
                                </SvgIcon>
                                </div>
                            </div>
                        ))
                    }
                    </div>
                ) : ''
            }
            <div className='flex-row'>
                <div className='automation-head'>
                    {t('When cards enter this column:')}
                </div>
            </div>
            <div className='flex-row flex-checkbox'>
                <input
                    type="checkbox"
                    id="set_user_availability"
                    name="set_user_availability"
                    checked={automationData.set_user_availability}
                    onChange={(e) => toggleBox(e) }
                />
                <label
                    className=""
                    htmlFor="set_user_availability"
                >
                {t('Set user availability to workstream\'s end date')}
              </label>
            </div>
            <div className='flex-row'>
                <div className='automation-head'>
                    {t('When trays exit this board:')}
                </div>
            </div>
            <div className='flex-row flex-checkbox'>
                <input
                    type="checkbox"
                    id="leave_user"
                    name="leave_user"
                    checked={automationData.leave_user}
                    onChange={(e) => toggleBox(e) }
                />
                <label
                    className=""
                    htmlFor="leave_user"
                >
                {t('Leave user on column (duplicates user)')}
              </label>
            </div>
        </div>
    )
});

export default UserAutomation;